import { render, staticRenderFns } from "./OtpField.vue?vue&type=template&id=4973b3b0&scoped=true"
import script from "./OtpField.vue?vue&type=script&lang=js"
export * from "./OtpField.vue?vue&type=script&lang=js"
import style0 from "./OtpField.vue?vue&type=style&index=0&id=4973b3b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4973b3b0",
  null
  
)

export default component.exports